/*
  Guides overview search.
  Filters the already rendered guide cards on the current page while typing.
  Purely a progressive enhancement: without JavaScript the search field is
  hidden by CSS and every guide stays visible.
*/
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-blog-guides]').forEach(function (blogRoot) {
    var form = blogRoot.querySelector('[data-guide-search-form]');
    var input = blogRoot.querySelector('[data-guide-search-input]');
    var emptyMessage = blogRoot.querySelector('[data-guide-empty]');
    var status = blogRoot.querySelector('[data-guide-status]');
    var groups = blogRoot.querySelectorAll('[data-guide-group]');
    var items = Array.prototype.slice.call(blogRoot.querySelectorAll('[data-guide-item]'));

    if (!form || !input) {
      return;
    }

    // Accent-insensitive matching so "uber" also finds "über".
    function normalize(value) {
      return (value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim();
    }

    items.forEach(function (item) {
      item.guideSearchText = normalize(item.getAttribute('data-guide-search'));
    });

    function applyFilter() {
      var terms = normalize(input.value).split(/\s+/).filter(Boolean);
      var visibleCount = 0;

      items.forEach(function (item) {
        var matches = terms.every(function (term) {
          return item.guideSearchText.indexOf(term) !== -1;
        });

        item.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }
      });

      groups.forEach(function (group) {
        group.hidden = !group.querySelector('[data-guide-item]:not([hidden])');
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount > 0;
      }

      if (status && terms.length > 0) {
        status.textContent = (status.getAttribute('data-guide-status-template') || '').replace('[count]', visibleCount);
      } else if (status) {
        status.textContent = '';
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilter();
    });

    input.addEventListener('input', applyFilter);
  });
});
